class ModalBasketItem {
  constructor(element) {
    this.element = element;
    this.productId = parseInt(element.dataset.productId);
    this.minus = element.querySelector('[data-minus]');
    this.plus = element.querySelector('[data-plus]');
    this.quantityInput = element.querySelector('[data-input-quantity]');
    this.external = element.dataset.product;
    this.price = element.querySelector('[data-price]');
    this.oldPrice = element.querySelector('[data-old-price]');
    this.remove = element.querySelector('[data-remove]');
  }

  getQuantity() {
    return parseFloat(this.quantityInput.value);
  }

  setQuantity(quantity) {
    quantity = Math.round(quantity * 100);
    this.quantityInput.value = quantity / 100;
  }

  setPrice(price) {
    price = Math.round(price * 100)
    this.price.innerHTML = `${price / 100} ₽`
  }

  setOldPrice(oldPrice) {
    if (this.oldPrice) {
      oldPrice = Math.round(oldPrice * 100);
      this.oldPrice.innerHTML = `${oldPrice / 100} ₽`
    }
  }

  disable() {
    this.element.classList.add('_disabled');
  }

  enable() {
    this.element.classList.remove('_disabled');
  }

  delete() {
    this.element.remove();
  }
}